import type { RootState } from "types";
import { initialState } from "app/containers/Features/containers/TeamSettings/container/Projects/container/ProjectComponent/redux/initialState";
import { createSelector } from "@reduxjs/toolkit";

// Select domain from the state
const selectDomain = (state: RootState) => state.componentState || initialState;

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectIsComponentModalOpen = createSelector(
  [selectDomain],
  (state) => state?.isComponentModalOpen ,
);

export const selectButtonLoading = createSelector(
  [selectDomain],
  (state) => state.buttonLoading,
);
export const selectFieldLoading = createSelector(
  [selectDomain],
  (state) => state.fieldLoading,
);

export const selectIsArchiveModalOpen = createSelector(
  [selectDomain],
  (state) => state?.isArchiveModalOpen,
);
export const selectComponentFormData = createSelector(
  [selectDomain],
  (state) => state.form,
);

export const selectArchiveComponentData = createSelector(
  [selectDomain],
  (state) => state?.archiveComponentData,
);

export const selectComponentsList = createSelector(
  [selectDomain],
  (state) => state?.list,
);


export const selectPagination = createSelector(
  [selectDomain],
  (state) => state?.pagination,
);

export const selectHasMore = createSelector([selectPagination], (pagination) => {
  if (!pagination) return false;
  return pagination.page < pagination.totalPage;
});
